/**
 * BEPRO Shop - Toast notifikacije
 */

let container = null;

function getContainer() {
	if (container && document.body.contains(container)) return container;
	container = document.createElement('div');
	container.className = 'bepro-toast-container';
	document.body.appendChild(container);
	return container;
}

/**
 * Prikaži toast notifikaciju
 * @param {string} message - Tekst poruke
 * @param {string} type - 'success' | 'error' | 'info'
 * @param {number} duration - Trajanje u ms (default 3000)
 */
export function showToast(message, type = 'success', duration = 3000) {
	const wrap = getContainer();

	const toast = document.createElement('div');
	toast.className = `bepro-toast bepro-toast--${type}`;

	const icons = {
		success: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M15 4.5L6.75 12.75L3 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
		error: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
		info: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7.5" stroke="currentColor" stroke-width="1.5"/><path d="M9 8V13M9 6V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
	};

	toast.innerHTML = `
		<span class="bepro-toast__icon">${icons[type] || icons.info}</span>
		<span class="bepro-toast__text">${message}</span>
		<button class="bepro-toast__close" aria-label="Zatvori">
			<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
		</button>
	`;

	// Close button
	toast.querySelector('.bepro-toast__close').addEventListener('click', () => {
		dismissToast(toast);
	});

	wrap.appendChild(toast);

	// Animate in
	requestAnimationFrame(() => {
		toast.classList.add('bepro-toast--visible');
	});

	// Auto dismiss
	if (duration > 0) {
		setTimeout(() => dismissToast(toast), duration);
	}

	return toast;
}

function dismissToast(toast) {
	if (!toast || toast._dismissed) return;
	toast._dismissed = true;
	toast.classList.remove('bepro-toast--visible');
	toast.classList.add('bepro-toast--hiding');
	setTimeout(() => {
		if (toast.parentNode) toast.parentNode.removeChild(toast);
	}, 300);
}

export default { show: showToast };
